export default __webpack_public_path__ + "src/_images/Discover_Logo.png";